'use client';

import {
  Button,
  Dialog,
  DialogContent,
  DialogDefaultActionBox,
  DialogDefaultLayout,
  DialogDefaultRounded,
  DialogDescription,
  DialogDimMotion,
  DialogFooter,
  DialogHeader,
  DialogMotion,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
  Dim,
  IcDelete,
  IconButton,
  Typography,
} from '@musinsa/mds';

interface DialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  title?: React.ReactNode;
  message?: React.ReactNode;
  showDeleteButton?: boolean;
  confirmButtonText?: string;
  onConfirm?: () => void;
  cancelButtonText?: string;
  onCancel?: () => void;
  children?: React.ReactNode;
}

export function DialogComponent({
  isOpen,
  onOpenChange,
  title,
  message,
  showDeleteButton = false,
  confirmButtonText = '확인',
  onConfirm,
  cancelButtonText,
  onCancel,
  children,
}: DialogProps) {
  const handleClose = () => {
    onOpenChange(false);
  };

  const handleConfirm = () => {
    onConfirm?.();
    handleClose();
  };

  const handleCancel = () => {
    onCancel?.();
    handleClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      {children && <DialogTrigger asChild>{children}</DialogTrigger>}
      <DialogPortal>
        <DialogOverlay>
          <DialogDimMotion>
            <Dim />
          </DialogDimMotion>
        </DialogOverlay>
        <DialogContent>
          <DialogMotion>
            <DialogDefaultRounded>
              <DialogDefaultLayout>
                <DialogHeader>
                  {title && (
                    <DialogTitle>
                      <Typography
                        variant="body14pxMed"
                        colorScheme="black"
                        style={{ whiteSpace: 'pre-line' }}
                      >
                        {title}
                      </Typography>
                    </DialogTitle>
                  )}
                  {message && (
                    <DialogDescription>
                      <Typography
                        variant="body13pxReg"
                        colorScheme="gray-600"
                        style={{ whiteSpace: 'pre-line' }}
                      >
                        {message}
                      </Typography>
                    </DialogDescription>
                  )}
                  {showDeleteButton && (
                    <IconButton size="size28x28" onClick={handleClose}>
                      <IcDelete />
                    </IconButton>
                  )}
                </DialogHeader>
                <DialogFooter>
                  <DialogDefaultActionBox>
                    {cancelButtonText && (
                      <Button
                        className="w-full"
                        size={40}
                        variant="secondary"
                        onClick={handleCancel}
                      >
                        <Typography variant="body14pxMed">{cancelButtonText}</Typography>
                      </Button>
                    )}
                    <Button className="w-full" size={40} variant="primary" onClick={handleConfirm}>
                      <Typography variant="body14pxMed">{confirmButtonText}</Typography>
                    </Button>
                  </DialogDefaultActionBox>
                </DialogFooter>
              </DialogDefaultLayout>
            </DialogDefaultRounded>
          </DialogMotion>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
